/*************************************************/
/* MENU                                          */
/*************************************************/
export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--lvl-2';
    const submenuSelector = '.menu-nav--lvl-2';
    const headerSelector = '.header';
    const parentMenuEnterEvents = ['focusin', 'mouseenter'];
    const activeClass = "active";
    let activeSubMenu = null;
    const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
    const header = document.querySelector(headerSelector);

    const init = () => {

        if (parentMenuItems.length > 0 && header) {
            header.addEventListener('mouseleave', (event) => {
                const toElement = event.relatedTarget;
                
                // Check if the mouse has left the header and menu
                if (activeSubMenu && !header.contains(toElement) && !activeSubMenu.contains(toElement)) {
                    closeSubMenu(activeSubMenu);
                }
            });

            parentMenuItems.forEach(item => {
                parentMenuEnterEvents.forEach(event => {
                    item.addEventListener(event, () => {
                        const subMenu = item.querySelector(submenuSelector);
                        if (subMenu) {

                            // Close the currently active submenu (if any) before opening a new one
                            if (activeSubMenu && activeSubMenu !== subMenu) {
                                closeSubMenu(activeSubMenu);
                            }

                            openSubMenu(subMenu);
                        } else {
                            if (activeSubMenu) {
                                closeSubMenu(activeSubMenu);
                            }
                        }
                    });
                });
            });
        }
    };

    const openSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', false);
        subMenu.classList.add(activeClass);
        activeSubMenu = subMenu;
        header.querySelector(".header__main").classList.add("active-menu");
    };

    const closeSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', true);
        subMenu.classList.remove(activeClass);
        activeSubMenu = null;
        header.querySelector(".header__main").classList.remove("active-menu");
    };

    init();
}
